import '../../../../../filtersGrid.scss';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useMediaQuery } from '@mui/material';
import SearchButton from '../../../../../../components/SearchButton/SearchButton';
import MarcasModal from '../../../../../marcas/marcasModal/marcasModal';
import RamosModal from '../../../../../ramos/ramosModal/ramosModal';
import RubrosModal from '../../../../../rubros/rubrosModal/rubrosModal';
import SubrubrosModal from '../../../../../subrubros/subrubrosModal/subrubrosModal';

Modal.setAppElement('#root');

const FiltersGrid = ({
  searchInputRef,
  searchTerm,
  onSearch,
  onClose,
  setSearchIDMar,
  setSearchDescMar,
  setSearchIDRam,
  setSearchDescRam,
  setSearchIDRub,
  setSearchDescRub,
  setSearchIDSubr,
  setSearchDescSubr,
  searchIDRam,
  searchIDRub,
  searchSelectRef,
  handleDesChange,
  handleClearDes }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchIDFilter, setSearchIDFilter] = useState(""); // Filtro por ID
  const [searchDescFilter, setSearchDescFilter] = useState(""); // Filtro por descripción

  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    if (!isSmallScreen) {
      setIsModalOpen(false); // Cierra el modal al cambiar a pantallas grandes
    }
  }, [isSmallScreen]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      {isSmallScreen ? (
        <>
          <button className="filterButton" onClick={handleOpenModal}>
            Filtros De Búsqueda
          </button>

          <Modal
            isOpen={isModalOpen}
            onRequestClose={handleCloseModal}
            contentLabel="Seleccionar Filtros"
            className="modalScreen"
            overlayClassName="overlayScreen"
          >
            <h2>Filtros de Búsqueda</h2>
            <div className="modalContent">
 
              <SearchButton
                searchInputRef={searchInputRef}
                searchTerm={searchTerm} // Muestra el valor del filtro actual
                onSearch={onSearch}
                onClose={() => {
                  setSearchDescFilter(""); // Limpia el filtro
                  onClose();
                }}
                tipo={0}
              />
              <SearchButton
                searchSelectRef={searchSelectRef}
                handleDesChange={handleDesChange}
                handleClearDes={handleClearDes}
                tipo={2}
              />
              <MarcasModal
                handleChange={(id) => setSearchIDMar(id)}
                handleDescChange={(desc) => setSearchDescMar(desc)}
              />

              <RamosModal
                handleChange={(id) => setSearchIDRam(id)}
                handleDescChange={(desc) => setSearchDescRam(desc)}
                handleRubChange={(id) => setSearchIDRub(id)}
                handleSubrChange={(id) => setSearchIDSubr(id)}
              />

              {searchIDRam && (
                <RubrosModal
                  handleChange={(id) => setSearchIDRub(id)}
                  handleDescChange={(desc) => setSearchDescRub(desc)}
                  handleSubrChange={(id) => setSearchIDSubr(id)}
                  idSelectorRam={searchIDRam} />

              )}

              {searchIDRam && searchIDRub && (
                <SubrubrosModal
                  handleChange={(id) => setSearchIDSubr(id)}
                  handleDescChange={(desc) => setSearchDescSubr(desc)}
                  idSelectorRam={searchIDRam}
                  idSelectorRub={searchIDRub} />

              )}

            </div>
            <button className="modalCloseButton" onClick={handleCloseModal}>
              ❌
            </button>
          </Modal>
        </>
      ) : (
          <div className="searchContainer">
            <div className="row">
              <SearchButton
                searchInputRef={searchInputRef}
                searchTerm={searchTerm}
                onSearch={onSearch}
                onClose={() => {
                  setSearchDescFilter(""); 
                  onClose();
                }}
                tipo={0}
              />
              <SearchButton
                searchSelectRef={searchSelectRef}
                handleDesChange={handleDesChange}
                handleClearDes={handleClearDes}
                tipo={2}
              />
              <MarcasModal
                handleChange={(id) => setSearchIDMar(id)}
                handleDescChange={(desc) => setSearchDescMar(desc)}
              />
              

              <RamosModal
                handleChange={(id) => setSearchIDRam(id)}
                handleDescChange={(desc) => setSearchDescRam(desc)}
                handleRubChange={(id) => setSearchIDRub(id)}
                handleSubrChange={(id) => setSearchIDSubr(id)}
              />
        
              {searchIDRam && (
                <RubrosModal
                  handleChange={(id) => setSearchIDRub(id)}
                  handleDescChange={(desc) => setSearchDescRub(desc)}
                  handleSubrChange={(id) => setSearchIDSubr(id)}
                  idSelectorRam={searchIDRam} />
        
              )}
        
              {searchIDRam && searchIDRub && (
                <SubrubrosModal
                  handleChange={(id) => setSearchIDSubr(id)}
                  handleDescChange={(desc) => setSearchDescSubr(desc)}
                  idSelectorRam={searchIDRam}
                  idSelectorRub={searchIDRub} />
        
              )}
            </div>
          </div>
        )}
    </>
  );
};

export default FiltersGrid;
